<div provideParentForm>
    <avi-input-container helperText="{{ l10nKeys.syslogServerHelperText | vtranslate }}">
        <label
            aviLabelWithTooltip
            [objectType]="objectType"
            fieldName="syslog_servers"
            for="syslog-servers"
        >
            {{ l10nKeys.syslogServerLabel | vtranslate }}
        </label>
        <avi-repeated-strings
            name="syslog-servers"
            id="syslog-servers"
            [placeholder]="l10nKeys.syslogServerPlaceholder | vtranslate"
            [objectType]="objectType"
            fieldName="syslog_servers"
            [ngModel]="syslogServers"
            (ngModelChange)="onSyslogServersUpdate($event)"
            regexPattern="anyIPOrValidDomainName"
        ></avi-repeated-strings>
    </avi-input-container>
    <avi-checkbox
        [(ngModel)]="syncSyslogToSE"
        name="sync-syslog-to-se"
        [objectType]="objectType"
        fieldName="sync_syslog_to_se"
        (ngModelChange)="onSyncSyslogToSEChanged($event)"
    >
        {{ l10nKeys.syncTheSyslogServersToSeLabel | vtranslate }}
    </avi-checkbox>
</div>
